<template>
  <!--
      作者 rj.wu
      时间：2021-02-01
      描述：会员-会员升级记录
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称或手机">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称或手机"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.change_type" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option label="后台设置" value="10"></el-option>
            <el-option label="自动升级" value="20"></el-option>
            <!-- <el-option label="购买升级" value="30"></el-option>
            <el-option label="过期降级" value="40"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="log_id" label="ID" width="100" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="100">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户" width="240">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
              <p>手机号：{{scope.row.user.mobile}}</p>
            </template>
          </el-table-column>
          <el-table-column label="变更后等级" width="200">
            <template slot-scope="scope">
              <p>{{scope.row.oldgrade.name}}</p>
            </template>
          </el-table-column>
          <el-table-column label="变更前等级" width="200">
            <template slot-scope="scope">
              <p>{{scope.row.oldgrade.name}}</p>
            </template>
          </el-table-column>

          <el-table-column prop="change_typet" label="变更类型" width="200" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.change_type==10">后台设置</p>
              <p v-if="scope.row.change_type==20">自动升级</p>
              <p v-if="scope.row.change_type==30">购买升级</p>
              <p v-if="scope.row.change_type==40">过期降级</p>
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注" width="220">
          </el-table-column>
          <el-table-column prop="create_time" label="升级时间" width="200" sortable="custom"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {

    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nickName: '',
          user_id: '',
          change_type: '',
          create_time: ''
        },
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        UserApi.gradeLog(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/grade/part/Log.vue